import React from "react";

/**
 * MobileAppHeroDummy.jsx
 *
 * - Uses pure CSS phone-cm-hc29s (dummy mockups) on the right.
 * - Wave-shaped bottom (CSS).
 * - Header + hero content left.
 * - Smooth CSS animations, responsive layout.
 *
 * Note: the uploaded file path (from convo history) is available below if you
 * decide to use the real image instead of the CSS mockups.
 */
const UPLOADED_IMAGE = "/mnt/data/Screenshot 2025-11-16 151519.png"; // uploaded file path (kept for reference)

export default function HeroCard29() {
  return (
    <>
      

      <section className="mah-hero" role="region" aria-label="Mobile app hero">
       <header className="mah-header">
        <div className="mah-header-inner">
          <div className="mah-brand">
            <div className="mah-logo">MA</div>
            <div className="mah-title">Mobile Application</div>
          </div>

          <nav className="mah-nav" aria-label="Main navigation">
            <a href="#home">Home</a>
            <a href="#blog">Blog</a>
            <a href="#page">Page</a>
            <a href="#testi">Testimonials</a>
            <a href="#team">Team</a>
            <a href="#contact">Contact</a>
          </nav>

          <div className="mah-actions">
            <button className="mah-buy">Buy Now</button>
          </div>
        </div>
      </header> {/* LEFT CONTENT */}
      <div className="mah-hero-outer">  <div className="mah-left">
          <h1 className="mah-h1">WELCOME TO MOBILE APPLICATION</h1>
          <p className="mah-lead">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            Lorem Ipsum has been the industry's standard dummy text.
          </p>

          <div className="mah-ctas">
            <button className="btn-outline">Tell me more</button>
            <button className="btn-solid">Sign me up</button>
          </div>
        </div>

        {/* RIGHT: CSS Dummy Phone Mockups */}
        <div className="mah-right" aria-hidden>
          <div className="phone-cm-hc29-stack">
            <div className="phone-cm-hc29 phone-cm-hc29-back">
              <div className="screen-cm-hc29 screen-cm-hc29-back" />
            </div>

            <div className="phone-cm-hc29 phone-cm-hc29-mid">
              <div className="screen-cm-hc29 screen-cm-hc29-mid">
                <div className="card-cm-hc29-list">
                  <div className="card-cm-hc29 small" />
                  <div className="card-cm-hc29 small" />
                  <div className="card-cm-hc29 small" />
                </div>
              </div>
            </div>

            <div className="phone-cm-hc29 phone-cm-hc29-front">
              <div className="screen-cm-hc29 screen-cm-hc29-front">
                <div className="calendar-cm-hc29">
                  <div className="cal-header">Monday<span>Feb 14</span></div>
                  <div className="cal-grid">
                    {Array.from({ length: 30 }).map((_, i) => (
                      <div key={i} className={`cal-day ${i===13 ? "active" : ""}`}>{i+1}</div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
</div>
        {/* decorative wave bottom */}
        <div className="mah-wave" aria-hidden>
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 40 C 360 120 1080 -40 1440 40 L1440 120 L0 120 Z" fill="white" />
          </svg>
        </div>
      </section>

      <style>{`
/* ---------------- RESET ---------------- */
:root{
  --bg1: linear-gradient(90deg,#ff6b6b,#ff8c6b);
  --accent: #ff6b6b;
  --white: #fff;
  --muted: rgba(255,255,255,0.9);
}

/* ---------- HEADER ---------- */
.mah-header {
  position: relative;
  background: transparent;
  padding: 18px 6%;
  z-index: 40;
}
.mah-header-inner {
  display:flex;
  align-items:center;
  gap:16px;
  max-width: 1200px;
  margin: 0 auto;
}
.mah-brand { display:flex; align-items:center; gap:12px; }
.mah-logo {
  width:48px; height:48px; border-radius:8px; background:#fff5f5;
  display:grid; place-items:center; color:var(--accent); font-weight:900; font-size:1.05rem;
  box-shadow: 0 8px 28px rgba(0,0,0,0.08);
}
.mah-title { font-weight:700; color: #fff; margin-left:4px; }

.mah-nav { margin-left: 24px; display:flex; gap:18px; flex:1; align-items:center; justify-content:center; }
.mah-nav a { color: rgba(255,255,255,0.9); text-decoration:none; font-weight:700; opacity:0.95; }
.mah-nav a:hover { opacity:1; transform: translateY(-1px); }

.mah-actions { display:flex; gap:12px; align-items:center; }
.mah-buy {
  background: rgba(255,255,255,0.95);
  color: var(--accent);
  border: none;
  padding:10px 14px; border-radius:8px; font-weight:800; cursor:pointer;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
}

/* ---------- HERO ---------- */
.mah-hero {
  position: relative;
 
  background: var(--bg1);

  
}
.mah-hero-outer{display: grid; position: relative;
  grid-template-columns: 1fr 560px;
  align-items: center;
  gap: 2rem;}
/* left content */
.mah-left { padding: 8% 6% 6% 6%; z-index: 5; color: white; }
.mah-h1 {
  font-size: clamp(1.6rem, 4.6vw, 3.6rem);
  margin: 0 0 18px; line-height: 1;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}
.mah-lead { max-width: 48ch; color: rgba(255,255,255,0.95); margin-bottom: 20px; }

.mah-ctas { display:flex; gap:14px; align-items:center; }
.btn-outline {
  background: transparent;
  color: white;
  border: 2px solid rgba(255,255,255,0.9);
  padding: 12px 20px;
  border-radius: 28px;
  font-weight:800;
  cursor:pointer;
}
.btn-outline:hover { transform: translateY(-4px); box-shadow: 0 18px 40px rgba(0,0,0,0.12); }

.btn-solid {
  background: white;
  color: var(--accent);
  border: none;
  padding: 12px 22px;
  border-radius: 28px;
  font-weight: 900;
  cursor: pointer;
}
.btn-solid:hover { transform: translateY(-4px); }

/* ---------- RIGHT PHONE MOCKUPS (CSS only) ---------- */
.mah-right { display:flex; align-items:center; justify-content:center; padding-right: 6%; z-index: 6; }

/* Stack wrapper */
.phone-cm-hc29-stack { position: relative; width: 420px; height: 520px; top:-30px; }

/* Base phone-cm-hc29 style */
.phone-cm-hc29 {
  position: absolute;
  right: 0;
  width: 240px;
  height: 480px;
  border-radius: 34px;
  background: #111;
  box-shadow: 0 30px 80px rgba(0,0,0,0.05);
  transform-origin: center;
  transition: transform 420ms cubic-bezier(.2,.8,.2,1);
 
}

/* Back phone-cm-hc29 (slightly rotated) */
.phone-cm-hc29-back {
  right: 22%;
  top: 20%;
  width: 210px; height: 410px;
  background: linear-gradient(180deg,#f5f5f5,#e9e9e9);
  transform: rotate(-8deg) scale(0.9);
  z-index: 1;
  border: 8px solid #f1f1f1;
  border-radius: 26px;
}

/* mid phone-cm-hc29 */
.phone-cm-hc29-mid {
  right: 9%;
  top: 8%;
  width: 230px; height: 450px;
  background: linear-gradient(180deg,#ffffff,#fbfbfb);
  transform: rotate(-4deg) scale(0.96);
  z-index: 2;
  border-radius: 30px;
  border: 8px solid rgba(255,255,255,0.95);
}

/* front phone-cm-hc29 (main) */
.phone-cm-hc29-front {
  right: 0;
  top: 0;
  width: 240px; height: 480px;
  background: linear-gradient(180deg,#fff,#fff);
  z-index: 3;
  border: 10px solid #fff;
}

/* phone-cm-hc29 screen-cm-hc29s */
.screen-cm-hc29 {
  position: absolute;
  inset: 18px 18px 18px 18px;
  border-radius: 20px;
  overflow: hidden;
}

/* decorative content for back/mid/front */
.screen-cm-hc29-back { background: linear-gradient(180deg,#efeef1,#f5f3f5); }
.screen-cm-hc29-mid { background: linear-gradient(180deg,#f9fafc,#ffffff); display:flex; align-items:center; justify-content:center; padding:18px; }
.screen-cm-hc29-front {
  background: linear-gradient(180deg,#fffefc,#fff);
  display:flex;
  align-items:flex-start;
  justify-content:center;
  padding: 22px;
}

/* small card-cm-hc29s on mid */
.card-cm-hc29-list { display:flex; flex-direction:column; gap:12px; width:100%; }
.card-cm-hc29.small { height:70px; border-radius:12px; background: linear-gradient(90deg,#ffe8e8,#fff0f0); box-shadow: inset 0 1px 0 rgba(255,255,255,0.6); }

/* calendar-cm-hc29 style for front */
.calendar-cm-hc29 { width: 100%; height: 100%; display:flex; flex-direction:column; gap:12px; }
.cal-header { font-weight:800; color:#ff6b6b; display:flex; justify-content:space-between; align-items:center; padding:6px 8px; }
.cal-header span { font-weight:700; color:#ff9474; font-size:0.9rem; }
.cal-grid {
  display:grid;
  grid-template-columns: repeat(7, 1fr);
  gap:6px;
}
.cal-day {
  background: #fff9f9; color:#333; border-radius:6px; padding:8px 6px; font-size:0.85rem; text-align:center;
}
.cal-day.active {
  background: linear-gradient(90deg,#ff6b6b,#ff9b6b); color:#fff; font-weight:800;
}

/* hover effect for the phone-cm-hc29 stack */
.phone-cm-hc29-stack:hover .phone-cm-hc29-front { transform: translateY(-6px) rotate(0deg) scale(1.02); }
.phone-cm-hc29-stack:hover .phone-cm-hc29-mid { transform: translateY(-2px) rotate(-2deg) scale(1); }
.phone-cm-hc29-stack:hover .phone-cm-hc29-back { transform: translateY(-1px) rotate(-6deg) scale(0.92); }

/* ---------- WAVE BOTTOM ---------- */
.mah-wave {
  position: absolute;transform:scale(1.4);
  left: 0; right: 0; bottom: 31px; z-index: 4;
  height: 100px;
  pointer-events: none;
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1100px) {
.mah-wave {
 bottom: -81px; 
}
  .mah-hero-outer { grid-template-columns: 1fr 420px; }
  .phone-cm-hc29-stack { transform: scale(0.9); }
}
@media (max-width: 860px) {
.mah-wave {
 bottom: -81px; 
}
  .mah-hero-outer { grid-template-columns: 1fr;  min-height: 64vh; }
  .mah-right { order: 2; margin-top: 28px; justify-content: center; }
  .mah-left { order: 1; padding-top: 16px; }
  .mah-header-inner { gap: 8px; }
  .mah-nav { display:none; }
}
@media (max-width: 420px) {
.mah-wave {
 bottom: -81px; 
}
  .phone-cm-hc29-stack {  } /* hide phone-cm-hc29s for tiny screen-cm-hc29s */
  .mah-h1 { font-size: 1.4rem; }
  .mah-lead { font-size: 0.95rem; }
  .btn-outline, .btn-solid { padding: 10px 12px; font-size: 0.9rem; }
}

/* subtle entrance animations */
.mah-left, .phone-cm-hc29-stack { animation: fadeUp .9s ease both; }
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
}
      `}</style>
    </>
  );
}
